// export constants
export const K_ID = 'id';

// ECs
export const EC_SYS = 'sys';
export const EC_USER = 'user';

// EAs
export const EA_POST = 'post';
export const EA_POST_RESULT = 'post-result';
export const EA_CHECK = 'check';
export const EA_GET = 'get';
export const EA_LOAD = 'load';
export const EA_LAUNCH = 'launch';
export const EA_ENABLE = 'enable';
export const EA_DISABLE = 'disable';
export const EA_SELECT = 'select';
export const EA_MOUSEUP = 'mouseup';
export const EA_SHOW = 'show';
export const EA_OPEN = 'open';
export const EA_CLOSE = 'close';
export const EA_ERROR = 'error';
export const EA_TRACK = 'track';
export const EA_INIT = 'init';
export const EA_CART = 'cart';
export const EA_REPLACE = 'replace';
export const EA_HOLD = 'hold';
export const EA_WARN = 'warn';
export const EA_CHANGE = 'change';

// ELs
export const EL_PREREQS = 'prereqs';
export const EL_PAY_MONTHLY = 'Pay Monthly';
export const EL_PAY_IN_FULL = 'Pay in Full';
export const EL_UPLIFT_PAYMENTS = 'UpLift.Payments';
export const EL_MWEB = 'mweb';
export const EL_PAYMENT = 'payment';
export const EL_MODAL = 'modal';
export const EL_LIGHTBOX = 'lightbox';
export const EL_LIGHTBOX_FAQ = 'lightbox-faq';
export const EL_LIGHTBOX_QUESTION = 'lightbox-question';
export const EL_TOOLTIP = 'tooltip';
export const EL_PAGE = 'page';
export const EL_BOOKING = 'booking';
export const EL_VALIDATION = 'validation';
export const EL_ORDER_INFO = 'order-info';
export const EL_FROM_PRICES = 'from-prices';
export const EL_ORDER_CREATE = 'order-create';
export const EL_ORDER_UPDATE = 'order-update';
export const EL_CARD = 'card';
export const EL_CONTAINER = 'container';
export const EL_HOTEL = 'hotel';
export const EL_SEARCH = 'search';
export const EL_COMPLETE = 'complete';
export const EL_CID = 'cid';
export const EL_ROOM_UPGRADE = 'room-upgrade';
export const EL_PLACE_ORDER = 'place-order';
export const EL_CHECKOUT = 'checkout';
export const EL_VERSION_MISMATCH = 'version_mismatch';
export const EL_PROMO = 'promo';
export const EL_PERSISTENCE = 'persistence';
export const EL_LOCALE = 'locale';
export const EL_CURRENCY = 'currency';
export const EL_API = 'api';
export const EL_IFRAME = 'iframe';

// EVs
export const EV_RESULT = 'result';
export const EV_MSG = 'msg';
export const EV_ORDER_ID = 'order_' + K_ID;
export const EV_BUILD = 'build';
export const EV_ORIGIN = 'origin';
export const EV_ORDER_AMOUNT = 'order_amount';
export const EV_STATUS = 'status';
export const EV_SOURCE = 'source';
export const EV_FROM = 'from';
export const EV_PAGE = 'page';
export const EV_TOTAL = 'from';
export const EV_REASON = 'reason';
export const EV_VALUE = 'value';
export const EV_VERSION = 'version';
export const EV_MERCHANT = 'merchant';
export const EV_QUERY = 'query';
export const EV_MESSAGE = 'message';
export const EV_RAW = 'raw';
export const EV_PROMO_AVAILABLE = 'promo_available';
export const EV_PROMO_ID = 'promo_id';
export const EV_LOCALIZATION = 'localization';

// K
export const K_DEBUG = 'debug';
export const K_OK = 'ok';
export const K_FAIL = 'fail';
export const K_LEVEL = 'level';
export const K_DEFAULT_EV = 'default_ev';
export const K_CLICK = 'click';
export const K_PRICING = 'pricing';
export const K_PRICING_BASE = 'pricing_base';

// Results
export const REASON_OUT_OF_FILTER = 'out of filter';
export const R_SHOW_IFRAME = 'show_iframe';
export const R_MCODE = 'mcode';
